import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const igsSection = document.querySelectorAll('.image-gallery-section');

    igsSection.forEach(section => {
        const sliderEl = section.querySelector('.igs-slider');

        new Swiper(sliderEl, {
            slidesPerView: 1.05,
            loop: true,
            grabCursor: true,
            centeredSlides: true,
            spaceBetween: 10,
            initialSlide: 2,
            navigation: {
                prevEl: sliderEl.parentNode.querySelector('.igs-button-prev'),
                nextEl: sliderEl.parentNode.querySelector('.igs-button-next'),
            },
            pagination: {
                el: sliderEl.parentNode.querySelector('.igs-pagination'),
                clickable: true,
            },
            effect: 'creative',
            creativeEffect: {
                perspective: true,
                limitProgress: 3,
                prev: {
                    translate: ['-108%', '10%', -100],
                    rotate: [0, 0, -10],
                    origin: 'bottom',
                },
                next: {
                    translate: ['108%', '10%', -100],
                    rotate: [0, 0, 10],
                    origin: 'bottom',
                },
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                    creativeEffect: {
                        perspective: true,
                        limitProgress: 3,
                        prev: {
                            translate: ['-120%', '10%', -100],
                            rotate: [0, 0, -10],
                            origin: 'bottom',
                        },
                        next: {
                            translate: ['125%', '10%', -100],
                            rotate: [0, 0, 10],
                            origin: 'bottom',
                        },
                    },
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    creativeEffect: {
                        perspective: true,
                        limitProgress: 3,
                        prev: {
                            translate: ['-120%', '10%', -100],
                            rotate: [0, 0, -10],
                            origin: 'bottom',
                        },
                        next: {
                            translate: ['125%', '10%', -100],
                            rotate: [0, 0, 10],
                            origin: 'bottom',
                        },
                    },
                },
            },
        });

        section.querySelectorAll('.igs-item').forEach(item => {
            const icon = item.querySelector('.plus-icon');
            const popup = item.querySelector('.igs-popup');

            if (icon) {
                icon.addEventListener('click', (e) => {
                    e.stopPropagation();

                    const allItems = item.parentNode.querySelectorAll('.igs-item');

                    // remove from siblings
                    allItems.forEach(sibling => {
                        if (sibling !== item) {
                            sibling.querySelector('.igs-popup') ?.classList.remove('is-active');
                        }
                    });

                    // add to current
                    popup.classList.toggle('is-active');
                });
            }
        });
    });
});